import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import { useQuery } from '@apollo/client'

import gql from 'graphql-tag'
import { DateTime } from 'luxon'
import CardMajorEvent from '@components/card-major-event/card-major-event'
import cardEventFragment from '@components/card-event/card-event.fragment'
import SrOnly from '@components/atoms/sr-only'
import useStyles from './major-events-card-container.styles'

const QUERY = gql`
query MajorEvents($where : EventFilter) {
    eventCollection(
      order: startDate_ASC,
      where: $where
    ) {
      total
      items {
        ${cardEventFragment}
    }
  }
}
`

const MajorEventsCardContainer = (props) => {
  const {
    items,
  } = props
  const styles = useStyles()
  const now = DateTime.local()
  const [live, setLive] = useState([])
  const [notLive, setNotLive] = useState([])

  const defaultQuery = items.reduce((prev, curr) => {
    prev.push({ eventCategory: { name: curr.name } })
    return prev
  }, [])
  const {
    data,
  } = useQuery(QUERY, {
    variables: {
      where: { OR: defaultQuery },
    },
  })

  // Show if event is Live, Completed, Upcoming
  const status = (item) => {
    const start = DateTime.fromISO(item.startDate)
    const end = DateTime.fromISO(item.endDate)
    if (start < now && end < now) {
      return 'Complete'
    } if (start <= now && end >= now) {
      return 'Live'
    }
    return 'Upcoming'
  }

  function isLive(item) {
    const start = DateTime.fromISO(item.startDate)
    const end = DateTime.fromISO(item.endDate)
    if (start <= now && end >= now) {
      return true
    }
    return false
  }

  function isNotLive(item) {
    const start = DateTime.fromISO(item.startDate)
    const end = DateTime.fromISO(item.endDate)
    if (start <= now && end >= now) {
      return false
    }
    return true
  }

  useEffect(() => {
    if (data?.eventCollection?.items?.length) {
      const itemsWithStatus = data.eventCollection.items.map((item) => ({
        ...item,
        status: status(item),
      }))
      // Break out events into two subarrays to show in non-sequental order
      setLive(itemsWithStatus.filter(isLive))
      setNotLive(itemsWithStatus.filter(isNotLive))
    }
  }, [data?.eventCollection?.items])

  return (
    <Box py={8} className={styles.root}>
      <Container className={styles.eventsWrapper}>
        <SrOnly>
          <h2>All Major Events</h2>
        </SrOnly>
        {data && live.length > 0 && live.map(item => (
          <CardMajorEvent
            key={item.sys.id}
            {...item}
          />
        ))}
        {data && notLive.length > 0 && notLive.map(item => (
          <CardMajorEvent
            key={item.sys.id}
            {...item}
          />
        ))}
      </Container>
    </Box>
  )
}

MajorEventsCardContainer.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      __typename: PropTypes.string,
      title: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.string,
    }),
  ),
}

export default MajorEventsCardContainer
